import { MapUtils } from '../../utility/map-utils.js';
import { cloneMap, DataModel, DataModelBuilder, isSameData,
  isSameMap, mapToData, SerializationContext, SerializedData } from '../../models/dto/dto.js';
import { Currency } from '../../models/serializable/currency.js';
import { PriceRange } from '../../models/serializable/price-range.js';
import { LocalizedString } from '../../models/serializable/localized-string.js';

export class ServiceAttendanceGroup extends DataModel {
  static readonly TYPE_ID: string = '8a4cf49a2bb94af097db44a55ec05acc';

  constructor(
        public readonly names: LocalizedString,
        public readonly groupSize: number,
        public readonly priceRanges: Map<Currency, PriceRange>,
        public readonly isPricePublic: boolean,
  ) {
    super();
  }

  get $typeId(): string {
    return ServiceAttendanceGroup.TYPE_ID;
  }

  static fromMap(context: SerializationContext, map: SerializedData): ServiceAttendanceGroup {
    return new ServiceAttendanceGroup(
        context.fromData(MapUtils.get<SerializedData>(map, 'names')),
        MapUtils.get<number>(map, 'groupSize'),
        MapUtils.getMap<Currency, PriceRange>(map, 'priceRanges', (k, v) => {
          return { key: k as Currency, value: context.fromData<PriceRange>(v as SerializedData) };
        }),
        MapUtils.get<boolean>(map, 'isPricePublic'),
    );
  }

  toMap(context: SerializationContext): SerializedData {
    return {
      'names': context.toData(this.names),
      'groupSize': this.groupSize,
      'priceRanges': mapToData(this.priceRanges, (k, v) => {
        return { key: k as string, value: context.toData(v) };
      }),
      'isPricePublic': this.isPricePublic,
    };
  }

  clone(): this {
    return new ServiceAttendanceGroup(
        this.names.clone(),
        this.groupSize,
        cloneMap(this.priceRanges, ((e) => e.clone())),
        this.isPricePublic,
    ) as this;
  }

  isSame(other: this): boolean {
    if(other === this) {
      return true;
    }

    return isSameData(other.names, this.names) &&
        other.groupSize === this.groupSize &&
        isSameMap(other.priceRanges, this.priceRanges) &&
        other.isPricePublic === this.isPricePublic;
  }
}

export class ServiceAttendanceGroupBuilder extends DataModelBuilder<ServiceAttendanceGroup> {
  build(context: SerializationContext, map: SerializedData): ServiceAttendanceGroup {
    return ServiceAttendanceGroup.fromMap(context, map);
  }
}
